import { SelectOption } from "@iddataweb/idw-common-ui/types";

export const getSelectedOption = (options: Array<SelectOption>, propertyValue: string) => {
    const option = options.find(workflow => workflow.value === propertyValue);
    if (option) {
        return option;
    }

    return null;
}